// extracted by mini-css-extract-plugin
module.exports = {"Container":"style_Container__1gRX0","TopMain":"style_TopMain__1F05k","Title":"style_Title__25uxH","ScreenBody":"style_ScreenBody__1ux1G","StoreList":"style_StoreList__2o9F4"};